import { Injectable } from '@angular/core';
import { CastingBooleanValue } from 'src/app/components/att-casting-view/formats/casting-boolean/casting-boolean.component';
import { Qualifier } from 'src/app/types/qualifier';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { CastingMode, CastingValue } from 'src/app/components/att-casting-view/att-casting-view.component';

@Injectable({
	providedIn: 'root'
})
export class BooleanQualifierService implements Qualifier {
	static supportedStats = ['count', 'first', 'last', 'max', 'min'];
	static FromString(value: string, booleanInfo: CastingBooleanValue): boolean {
		switch (value) {
			case 't':
			case 'f':
				return (value === 't');
		}
		return (value === booleanInfo.trueValue) ? true : false;
	}
	static ToString(value: boolean, booleanInfo: CastingBooleanValue): string {
		if ('' + value === '') {
			return '';
		}
		
		return (value === true) ? '' + booleanInfo.trueValue : '' + booleanInfo.falseValue;
	}
	static ToNumber(value: boolean): number {
		return (value === true) ? 1 : 0;
	}
	static FromNumber(value: number): boolean {
		return (value < 1) ? false : true;
	}
	static ToStringFromNumber(value: number, booleanInfo: CastingBooleanValue): string {
		const boolValue = BooleanQualifierService.FromNumber(value);
		return BooleanQualifierService.ToString(boolValue, booleanInfo);
	}
	static ToDB(value: boolean): string {
		return (value === true) ? 't' : 'f';
	}
	static FromDB(value: 't' | 'f'): boolean {
		return (value === 't') ? true : false;
	}
	public static GetDisplayValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
		if (!attribute.casting) {
			return val;
		}
		if (!attribute.casting[castingMode]) {
			return val;
		}
		if(val === '') {
			return '';
		}
		const casting: CastingValue = attribute.casting[castingMode] as CastingValue;
		const boolVal = BooleanQualifierService.GetNativeValue(attribute, castingMode, val);
		return BooleanQualifierService.ToString(boolVal, casting.boolean);

	}
	public static GetTextExportValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
		if ([undefined, null].indexOf(val) > -1) {
			return '';
		}
		return BooleanQualifierService.GetDisplayValue(attribute, castingMode, val);

	}
	public static GetNativeValue(attribute: AttributeInfo, castingMode: CastingMode, value: any): any {
		const casting: CastingValue = attribute.casting[castingMode];
		return BooleanQualifierService.FromString(value, casting.boolean);
	}
	public static SupportsStat(statName): boolean {
		return BooleanQualifierService.supportedStats.indexOf(statName) > -1;
	}
	constructor() { }

}
